import { Genders } from './Genders';
import { ReservationTypes } from './ReservationType';

export const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(email.toLowerCase()) || email.length === 0;
};

export const isValidEmailNotEmpty = (email) => {
  const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailRegex.test(email.toLowerCase());
};

export const isValidGstNumber = (number) => {
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  return gstRegex.test(number);
};

export const isValidMobile = (mobile) => {
  const mobileRegex = /^\d{10}$/;
  return mobileRegex.test(mobile) || mobile.length === 0;
};

export const isValidMobileNotEmpty = (mobile) => {
  const mobileRegex = /^\d{10}$/;
  return mobileRegex.test(mobile);
};

export const isValidUserId = (userId) => {
  const userIdRegex = /^[a-zA-Z0-9_]+$/;
  return userIdRegex.test(userId);
};

export const isValidName = (name) => {
  const nameRegex = /^[a-zA-Z\s]+$/;
  return nameRegex.test(name) || name.length === 0;
};

export const isValidNameNotEmpty = (name) => {
  const nameRegex = /^[a-zA-Z\s]+$/;
  return nameRegex.test(name);
};

export const isValidAge = (age, min, max) => (
  age >= min && age <= max
);

export const isValidGender = (gender) => (
  gender.id !== Genders.NOT_SPECIFIED.key
);

export const isSeniorCitizen = (traveller, srctnwAge, srctznAge) => (
  (traveller.gender.id === 'MALE' && traveller.age >= srctznAge) || (traveller.gender.id === 'FEMALE' && traveller.age >= srctnwAge)
);

export const isChild = (traveller, maxChildAge) => (
  traveller.age <= maxChildAge
);

export const isInfant = (traveller, minPassengerAge) => (
  traveller.age < minPassengerAge && traveller.age > 0
);

export const isHalfTicket = (traveller) => (
  traveller.reservationType.id === ReservationTypes.HALF_TICKET.key
);

export const validations = Object.freeze({
  userName: [
    {
      text: '3-35 characters',
      regex: /^[a-zA-Z0-9_]{3,35}$/,
    },
    {
      text: 'Only upper case letters, lower case letters and number',
      regex: /^[A-Za-z][A-Za-z0-9]*(?:_[A-Za-z0-9]+)*$/,
    },
  ],
  password: [
    {
      text: '8-15 case sensitive characters',
      regex: /^[a-zA-Z0-9@.!#$-]{8,15}$/,
    },
    {
      text: 'At least one small alphabet',
      regex: /(?=.*?[a-z])/,
    },
    {
      text: 'At least one capital alphabet',
      regex: /(?=.*?[A-Z])/,
    },
    {
      text: 'At least one number',
      regex: /(?=.*?[0-9])/,
    },
  ],
  email: [
    {
      text: '',
      regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    },
  ],
  mobileNumber: [
    {
      text: '',
      regex: /^\d{10}$/,
    },
  ],
  residentialMobileNumber: [
    {
      text: '',
      regex: /^\d{10}$/,
    },
  ],
  officeMobileNumber: [
    {
      text: '',
      regex: /^\d{10}$/,
    },
  ],
  securityAnswer: [
    {
      text: '3-20 characters',
      regex: /^[a-zA-Z0-9]{3,20}$/,
    },
    {
      text: 'Only lowercase letters and numbers',
      regex: /^[a-z0-9]+$/,
    },
  ],
  firstName: [
    {
      text: '',
      regex: /^[a-zA-Z]{1,30}$/,
    },
  ],
  lastName: [
    {
      text: '',
      regex: /^[a-zA-Z]{1,30}$/,
    },
  ],
  pinCode: [
    {
      text: '',
      regex: /^\d{6}$/,
    },
  ],
  officePinCode: [
    {
      text: '',
      regex: /^\d{6}$/,
    },
  ],
});

export const checkValidation = (value, validations) => value &&
  (!validations || validations.every((validation) => validation.regex.test(value)));
